<template>
  <div class="report-wrap tb">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-radio-group v-model="formSearch.reportType" @change="onTypeChange">
          <el-radio-button :label="item.value" v-for="(item, index) in reportTypeData" :key="index">{{ item.label }}</el-radio-button>
        </el-radio-group>
        <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.runLog_device_export"
        >
          <el-button
            class="table-set"
            style="vertical-align: top;"
            @click="onExport"
            :disabled="exporting"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>
        <el-form-item style="float: right;">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('report_device_log.ji_shen_hao')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onTypeChange"
      @clear="onClear"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
      <!-- 产品型号 -->
        <el-form-item :label="$t('report_device_log.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :placeholder="i18n.com_please_select"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 项目 -->
        <el-form-item :label="$t('report_device_log.xiang_mu_ming_cheng')">
          <el-input v-model="formSearch.locationName" clearable ></el-input>
        </el-form-item>
        <!-- 国家/省/市 -->
        <el-form-item :label="$t('report_device_log.guo_jia_sheng_shi')" v-if="formSearch.reportType === 0">
          <el-row :gutter="5">
            <el-col :span="8">
              <custom-select v-model="formSearch.countryCode" url="NationRegionTree"  :params="{ level: 1 }" width="100%" :props="{ label: 'name', value: 'code' }"></custom-select>
            </el-col>
            <el-col :span="8">
              <custom-select
                :auto="false"
                :listener="`${formSearch.countryCode|| null}`"
                url="NationRegionTree"
                filterable
                v-model="formSearch.provinceCode"
                :props="{ label: 'name', value: 'code' }"
                :params="{ code: formSearch.countryCode,level: 2 }"
                width="100%"
                :filterOptions="formSearch.countryCode"
                :dataFilter="dataFilterTree"
              ></custom-select>
            </el-col>
            <el-col :span="8">
              <custom-select
                :auto="false"
                :listener="formSearch.provinceCode"
                url="NationRegionTree"
                filterable
                v-model="formSearch.cityCode"
                :props="{ label: 'name', value: 'code' }"
                :params="{ code: formSearch.provinceCode,level: 3 }"
                :filterOptions="formSearch.provinceCode"
                width="100%"
                :dataFilter="dataFilterTree"
              ></custom-select>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- 地区 -->
        <!-- <el-form-item :label="$t('page_runLog_di_qu')">
          <el-input v-model="formSearch.region" clearable ></el-input>
        </el-form-item> -->
        <!-- 项目地址 -->
        <el-form-item :label="$t('report_device_log.xiang_mu_di_zhi')">
          <el-input v-model="formSearch.locationAddress" clearable ></el-input>
        </el-form-item>
        <!-- 售后公司 -->
        <el-form-item :label="$t('report_device_log.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName" style="width: 100%" clearable >
          </el-input>
        </el-form-item>
        <!-- 代理公司 -->
        <el-form-item :label="$t('report_device_log.zu_lin_fang')">
          <el-input v-model="formSearch.customerName" style="width: 100%" clearable >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('report_device_log.dai_li_gong_si')">
          <el-input v-model="formSearch.agentCoName" style="width: 100%" clearable >
          </el-input>
        </el-form-item>
        <!-- 时间 -->
        <el-form-item :label="$t('Common.com_time')" class="select-date">
          <!-- 天 -->
          <custom-date-picker
            v-show="formSearch.reportType === 0"
            v-model="dateTimes"
            type="daterange"
            align="right"
            unlink-panels
            :start-placeholder="$t('report_device_log.kai_shi_ri')"
            :end-placeholder="$t('report_device_log.jie_shu_ri')"
            format="yyyy-MM-dd"
            :picker-options="pickerOptionsIntervalMonthReport"
            :clearable="false"
          ></custom-date-picker>
          <!-- 历史报表 -->
          <!-- 年 -->
          <year-picker
            v-show="formSearch.reportType === 1"
            v-model="reportYearTime"
            class="year-picker"
          ></year-picker>
          <!-- 季度 -->
          <season-picker
            v-show="formSearch.reportType === 2"
            v-model="reportSeasonTime"
            ref="jidupicker"
            class="season-picker"
          >
          </season-picker>
          <!-- 月 -->
          <custom-date-picker
            v-show="formSearch.reportType === 3"
            v-model="reportMonthTime"
            type="monthrange"
            range-separator="—"
            format="yyyy-MM"
            value-format="yyyy-MM"
            align="right"
            placeholder=""
            :picker-options="pickerOptionsIntervalThreeYears"
            prefix-icon="icon icon-calendar"
            :clearable="false"
            :start-placeholder="$t('report_device_log.kai_shi_yue')"
            :end-placeholder="$t('report_device_log.jie_shu_yue')"
          ></custom-date-picker>
          <!--周 -->
          <week-picker
            v-show="formSearch.reportType === 4"
            v-model="reportWeekTime"
            class="week-picker"
          ></week-picker>
        </el-form-item>
        <el-form-item :label="$t('report_device_log.qu_yu_ming_cheng')" v-if="formSearch.reportType === 0">
          <el-input v-model="formSearch.siteName" style="width: 100%" clearable >
          </el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <!-- {{ tableList }} -->
      <custom-table
        v-if="formSearch.reportType === 0 && isInch"
        tableCode="device_log_ft"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['totalCleanArea','manualCleanArea', 'autonomousCleanArea', 'trainingCleanArea']"
        @sort="sortChange"
        @filter="filterChange"
      >
        <!--
          totalCleanArea
          manualCleanArea
          autonomousCleanArea
          trainingCleanArea
        -->
        <template v-slot:totalCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
        </template>
        <template v-slot:manualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.manualCleanArea)}}</span>
        </template>
        <template v-slot:autonomousCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.autonomousCleanArea)}}</span>
        </template>
        <template v-slot:trainingCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.trainingCleanArea)}}</span>
        </template>
      </custom-table>
      <custom-table
        v-if="formSearch.reportType === 0 && !isInch"
        tableCode="device_log"
        :stripe="true"
        @column="setColumn"
        height="100%"
        :index="true"
        :data="tableList"
        @sort="sortChange"
        @filter="filterChange"
      ></custom-table>

      <custom-table v-if="formSearch.reportType !== 0 && isInch" tableCode="device_log_date_ft" :stripe="true" @column="setColumn" height="100%" :index="true" :data="tableList" @sort="sortChange" @filter="filterChange"
      :slots="['attendanceRate','averageCleanArea','actualCleanArea','totalCleanArea','manualCleanArea','totalManualAveClean','manualAveValue','autonomousCleanArea','totalAutoAveClean','autoAveClean','trainingCleanArea']"
      >

        <!--
          attendanceRate
          averageCleanArea
          actualCleanArea
          totalCleanArea

          manualCleanArea
          totalManualAveClean
          manualAveValue
          autonomousCleanArea
          totalAutoAveClean
          autoAveClean
          trainingCleanArea
        -->
        <template v-slot:attendanceRate="scope">
          <span :style="getAttendanceColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
        <template v-slot:averageCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.averageCleanArea)}}</span>
        </template>
        <template v-slot:actualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.actualCleanArea)}}</span>
        </template>
        <template v-slot:totalCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.totalCleanArea)}}</span>
        </template>
        <template v-slot:totalManualAveClean="scope">
          <span>{{$formatLenLocal(scope.row.totalManualAveClean)}}</span>
        </template>
        <template v-slot:totalAutoAveClean="scope">
          <span>{{$formatLenLocal(scope.row.totalAutoAveClean)}}</span>
        </template>
        <template v-slot:manualAveValue="scope">
          <span>{{$formatLenLocal(scope.row.manualAveValue)}}</span>
        </template>
        <template v-slot:autoAveClean="scope">
          <span>{{$formatLenLocal(scope.row.autoAveClean)}}</span>
        </template>
        <template v-slot:manualCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.manualCleanArea)}}</span>
        </template>
        <template v-slot:autonomousCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.autonomousCleanArea)}}</span>
        </template>
        <template v-slot:trainingCleanArea="scope">
          <span>{{$formatLenLocal(scope.row.trainingCleanArea)}}</span>
        </template>
      </custom-table>
      <custom-table v-if="formSearch.reportType !== 0 && !isInch" tableCode="device_log_date" :stripe="true" @column="setColumn" height="100%" :index="true" :data="tableList" @sort="sortChange" @filter="filterChange"
      :slots="['attendanceRate']"
      >
        <template v-slot:attendanceRate="scope">
          <span :style="getAttendanceColor(scope.row.attendanceRate)">{{scope.row.attendanceRate}}</span>
        </template>
    </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import apis from '@/utils/apis';
import seasonPicker from '@/components/quarterlyRangePicker.vue';
import yearPicker from '@/components/yearRangePicker.vue';
import weekPicker from '@/components/weekRangePicker.vue';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';

export default {
  name: 'report',
  mixins: [resetFormSearchMixins],
  components: {
    seasonPicker,
    yearPicker,
    weekPicker,
  },
  computed: {
    reportTypeData() {
      return [
        {
          label: this.$t('report_device_log.ri'),
          value: 0,
        },
        {
          label: this.$t('report_device_log.zhou'),
          value: 4,
        },
        {
          label: this.$t('report_device_log.yue'),
          value: 3,
        },
        {
          label: this.$t('report_device_log.ji'),
          value: 2,
        },
        {
          label: this.$t('report_device_log.nian'),
          value: 1,
        },
      ];
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    // 选择日期配置
    pickerOptionDisAfter() {
      return {
        shortcuts: [
          {
            text: this.$t('Common.com_last_week'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_month'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: this.$t('Common.com_last_three_months'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
        disabledDate: time => moment(time).isAfter(this.$getLocalTime(), 'day'),
      };
    },
  },
  data() {
    return {
      provide: true,
      formSearch: {
        reportType: 0,
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,

        bodyNum: '',
        productCode: '',
        productName: '',
        locationId: '',
        locationName: '',
        // region: '',
        locationAddress: '',
        afterServiceName: '',
        customerName: '',
        agentCoName: '',

        beginTime: '',
        endTime: '',
        countryCode: '',
        provinceCode: '',
        cityCode: '',
        tagName: '',
        siteName: ''
      },
      tagId: '',
      tags: [],
      // 日
      dateTimes: [this.$momentWorld(moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))],
      reportYearTime: [`${moment(this.$getLocalTime()).year()}`, `${moment(this.$getLocalTime()).year()}`],
      reportSeasonTime: [`${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`, `${new Date().getFullYear()}-${this.getSeason(new Date().getMonth())}`],
      reportMonthTime: [`${moment(this.$getLocalTime()).add('month').format('YYYY-MM')}`, `${moment().add('month').format('YYYY-MM')}`],
      reportWeekTime: [this.$momentElLocal(moment().week(moment().week())), this.$momentElLocal(moment().week(moment().week()))],
      tableList: [],
      totalRows: 0,


      link: null,
      exporting: false,
    };
  },

  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    // this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
    // this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';

    this.onTypeChange();
  },
  methods: {
    // 获取列表
    getTableList() {
      if (this.formSearch.reportType === 0) {
        this.$getJSON(apis.DeviceReportDailyPage, { ...this.formSearch,
          // 字段改了要用startDate endDate传时间 天的格式
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
        })
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount', 'orderCharged', 'isAttendance']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      } else {
        // 清空 没有的筛选
        // this.formSearch.region = '';

        // this.formSearch.tagName = '';
        // this.formSearch.siteName = '';
        this.$getJSON(apis.DeviceReportSummaryPage, this.formSearch)
          .then((res) => {
            const data = res.data.list;
            this.nullValueToCrossbar(data, ['assistCount', 'orderCharged', 'isAttendance']);
            this.tableList = data;
            this.totalRows = res.data.total;
          })
          .catch(() => {
            this.tableList = [];
          });
      }
    },
    // 获取季度
    getSeason: function (month) {
      if (month < 3) {
        return '01';
      } else if (month < 6) {
        return '02';
      } else if (month < 9) {
        return '03';
      } else if (month < 12) {
        return '04';
      }
      return true;
    },
    onTypeChange() {
      switch (this.formSearch.reportType) {
        case 1:
          this.formSearch.beginTime = this.reportYearTime ? this.reportYearTime[0] : '';
          this.formSearch.endTime = this.reportYearTime ? this.reportYearTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 2:
          this.formSearch.beginTime = this.reportSeasonTime ? this.reportSeasonTime[0] : '';
          this.formSearch.endTime = this.reportSeasonTime ? this.reportSeasonTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 3:
          this.formSearch.beginTime = this.reportMonthTime ? this.reportMonthTime[0] : '';
          this.formSearch.endTime = this.reportMonthTime ? this.reportMonthTime[1] : '';
          this.onPageChange({ page: 1 });
          break;
        case 4:
          // 设置周的开始时间是星期一 1月1号是年开始的第一周
          moment.updateLocale('en', {
            week: {
              // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
              dow: 1, // Monday is the first day of the week.
              doy: 7, // The week that contains Jan 4th is the first week of the year.// 年份的第一周必须包含1月1日 (7 + 1 - 1)
            },
          });
          this.formSearch.beginTime = this.reportWeekTime.length ? moment(this.reportWeekTime[0]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.formSearch.endTime = this.reportWeekTime.length ? moment(this.reportWeekTime[1]).format('gggg-ww') : ''; // 转换时间因为现在是Date类型
          this.onPageChange({ page: 1 });
          break;
        default:
          // 天  由于没有用init-value的默认设置方式  传参要转成世界时间
          this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
          this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';
          this.onPageChange({ page: 1 });
      }
    },
    onClear() {
      this.formSearch.bodyNum = '';
      this.formSearch.productCode = '';
      this.formSearch.productName = '';
      this.formSearch.locationName = '';
      this.formSearch.locationId = '';
      this.formSearch.region = '';
      this.formSearch.locationAddress = '';
      this.formSearch.afterServiceName = '';
      this.formSearch.customerName = '';
      this.formSearch.agentCoName = '';
      this.formSearch.beginTime = '';
      this.formSearch.endTime = '';
      this.formSearch.countryCode = '';
      this.formSearch.provinceCode = '';
      this.formSearch.cityCode = '';
      this.formSearch.tagName = '';
      this.formSearch.siteName = '';
      this.dateTimes = [this.$momentWorld(moment(this.$getLocalTime()).subtract(1, 'day').format('YYYY-MM-DD 00:00:00')), this.$momentWorld(moment(this.$getLocalTime()).format('YYYY-MM-DD 23:59:59'))];
      // this.formSearch.beginTime = this.dateTimes ? this.dateTimes[0] : '';
      // this.formSearch.endTime = this.dateTimes ? this.dateTimes[1] : '';
      // this.reportYearTime = [];
      // this.reportSeasonTime = [];
      // this.reportMonthTime = [];
      // this.reportWeekTime = [];

      this.onTypeChange();
    },
    // 获取标列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName,
          });
        }
      });
      this.tags = arr;
    },
    // 出勤率
    getAttendanceColor(rate) {
    // 提取百分比值中的数字部分
      const value = parseFloat(rate);
      if (typeof value !== 'number') {
        return {};
      }
      // 根据条件返回不同的颜色样式
      if (value >= 90) {
        return { color: '#4CAF50' }; // 绿色
      } else if (value >= 70 && value < 90) {
        return { color: '#FFC107' }; // 黄色
      } else {
        return { color: '#F44336' }; // 红色
      }
    },
    onExport: function () {
      this.exporting = true;
      if (this.formSearch.reportType === 0) {
        this.exportTable('DeviceReportDailyExport', { ...this.formSearch,
          // 字段改了要用startDate endDate传时间 天的格式
          startDate: this.$momentElLocal(this.formSearch.beginTime, 'YYYY-MM-DD'),
          endDate: this.$momentElLocal(this.formSearch.endTime, 'YYYY-MM-DD'),
          platform: 'isynergy'
        }).then(() => {
          this.exporting = false;
        }).catch(() => {
          this.exporting = false;
        });
      } else {
        this.exportTable('DeviceReportSummaryExport', { ...this.formSearch, platform: 'isynergy' }).then(() => {
          this.exporting = false;
        }).catch(() => {
          this.exporting = false;
        });
      }
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    dataFilterTree: function (list, code) {
      // 要过滤第一层 那children那层
      if (list.length > 0 && list[0].code === code) {
        const node = list[0];
        return node && node.children ? node.children : [];
      } else {
        return list;
      }
    },
  },
};
</script>

<style lang="scss">
.report-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  overflow: hidden;
}

</style>
